import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import {SignaturePad} from "angular2-signaturepad/signature-pad";
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";
import * as moment from "moment";

/**
 * Generated class for the WebfleetSignaturePadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-signature-pad',
  templateUrl: 'webfleet-signature-pad.html',
})
export class WebfleetSignaturePadPage {
  date: any = moment().format('YYYY-MM-DD');
  signature = '';
  isDrawing = false;

  startTime: any;
  endTime: any;

  isPayed: any;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  private signaturePadOptions: Object = { // Check out https://github.com/szimek/signature_pad
    'minWidth': 2,
    'canvasWidth': 300,
    'canvasHeight': 200,
    'backgroundColor': '#444444',
    'penColor': '#cccccc'
  };


  constructor(public teamappProvider: TeamappProvider, public alertCtrl: AlertController, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController) {
  }

  ionViewDidEnter() {
    //this.signaturePad.clear();
  }

  timeAlert() {
    const alert = this.alertCtrl.create({
      title: 'Fehler!',
      subTitle: 'Die Startzeit muss vor der Endzeit liegen!',
      buttons: ['OK']
    });
    alert.present();
  }

  savePad() {
    if(this.startTime && this.endTime && this.date) {
      if(this.endTime > this.startTime) {
        if(this.isPayed) {
          this.signature = this.signaturePad.toDataURL();
          this.signature = encodeURIComponent(this.signature);
          console.log(this.signature);
          this.signaturePad.clear();
          this.teamappProvider.http_request('action=book_positions&payable=1&manual_type=manual_maintance&manual_comment='+this.signature+'&manual_start='+this.date+' '+this.startTime+':00&manual_end='+this.date+' '+this.endTime+':00', 'webfleet', false, true).then(data => {
            let ret: any = data;
            if(ret.success == true) {
              this.navCtrl.pop();
            } else {
              const alert = this.alertCtrl.create({
                title: 'Fehler!',
                subTitle: ret.msg,
                buttons: ['OK']
              });
              alert.present();
            }

          });
        } else {
          this.teamappProvider.http_request('action=book_positions&payable=0&manual_type=manual_maintance&manual_start='+this.date+' '+this.startTime+':00&manual_end='+this.date+' '+this.endTime+':00', 'webfleet', false, true).then(data => {
            let ret: any = data;
            if(ret.success == true) {
              this.navCtrl.pop();
            } else {
              const alert = this.alertCtrl.create({
                title: 'Fehler!',
                subTitle: ret.msg,
                buttons: ['OK']
              });
              alert.present();
            }
          });
        }
      } else {
        this.timeAlert();
      }

    } else {
      const toast = this.toastCtrl.create({
        message: 'Keine Zeitgaben angegeben',
        duration: 3000
      });
      toast.present();
    }


  }


  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetSignaturePadPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/webfleet-signature-pad/webfleet-signature-pad.ts